import React from 'react';
import { Route } from 'react-router';
import Shops from './containers/Shops';
import BrandLayout from './containers/BrandLayout';

export default () => (
  <Route component={BrandLayout}>
    <Route path="/brands/:brandRoute" component={Shops} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/app/brands/routes.jsx